import { gql } from "@grandvisionhq/graphql";
import { cartDetails } from "../../../fragments/operations/fragments/cart-details.js";
import { unknownLoyaltyDetailsFailure, invalidLoyaltyCardNumber } from "../../../fragments/operations/fragments/loyalty-point-failure.js";
const SET_LOYALTY_DETAILS = gql`
  mutation SetLoyaltyDetails($input: LoyaltyDetailsInput!) {
    setLoyaltyDetails(input: $input) {
      success
      message
      cart {
        ...LoyaltyPointsCartDetailsFragment
      }
      failures {
        ...UnknownSetLoyaltyDetailsFailureFragment
        ...InvalidLoyaltyCardNumberFragment
      }
    }
  }
  ${cartDetails}
  ${unknownLoyaltyDetailsFailure}
  ${invalidLoyaltyCardNumber}
`;
export {
  SET_LOYALTY_DETAILS
};
//# sourceMappingURL=set-loyalty-details.js.map
